module.exports = __webpack_public_path__ + "img/connectedness.3f7b9965.png";